// extracted by mini-css-extract-plugin
export default {"arrow":"SwiperArrow_arrow__8voxI","prev":"SwiperArrow_prev__x0pRz","next":"SwiperArrow_next__NrKUG"};